import { fetchOurApi, setUserCustomClaims } from "../utils/apiCalls";

const persistAccountId = async (user, accountId) => {
  const claimsResult = await setUserCustomClaims({
    uid: user.uid,
    accountId,
    accountCreationType: "company"
  });
  if (claimsResult?.error) {
    return {
      error: true,
      message: claimsResult.message || "Failed to complete account setup."
    };
  }
  await user.getIdToken(true);
  sessionStorage.setItem("accountId", accountId);
  return { success: true };
};

export const linkCustomerToRelationshipFromParams = async (user, { relId }) => {
  if (!relId) {
    return { error: true, message: "Missing relId." };
  }
  const { uid, displayName, email } = user;

  const result = await fetchOurApi({
    path: "/vendors/link-customer-to-relationship",
    method: "POST",
    data: { relId, uid, email, name: displayName },
    callback: (res) => res
  });

  const { buyerId } = result || {};
  if (!buyerId) {
    return { error: true, message: "Unable to resolve the inviting buyer." };
  }

  const persistResult = await persistAccountId(user, buyerId);
  if (persistResult?.error) {
    return persistResult;
  }
  return { success: true, accountId: buyerId };
};

export const linkUserToVendorFromParams = async (
  user,
  { vendorId, buyerId, role }
) => {
  if (!vendorId) {
    return { error: true, message: "Missing vendorId." };
  }
  const { uid, displayName, email } = user;

  const result = await fetchOurApi({
    path: "/vendors/link-user-to-vendor",
    method: "POST",
    data: {
      vendorId,
      uid,
      email,
      name: displayName,
      ...(buyerId ? { buyerId } : {}),
      ...(role ? { role } : {})
    },
    callback: (res) => res
  });

  if (result?.error) {
    return result;
  }

  const persistResult = await persistAccountId(user, vendorId);
  if (persistResult?.error) {
    return persistResult;
  }
  return { success: true, accountId: vendorId };
};

export const completeSelfServiceLinking = async ({
  user,
  companyData,
  buyerId
}) => {
  const { id: vendorId, stripeCustomerId } = companyData || {};
  if (!vendorId) {
    return { error: true, message: "Company data is missing an id." };
  }

  if (stripeCustomerId) {
    return { stripeRedirect: true };
  }

  return await linkUserToVendorFromParams(user, { vendorId, buyerId });
};
